import { Globe } from "lucide-react";

export default function Logo({ size = 36, showText = true }) {
    return (
        <div className="flex items-center gap-2" data-testid="discover-logo">
            <div className="relative inline-flex items-center justify-center"
                style={{ width: size, height: size }}>
                <div className="absolute inset-0 rounded-full bg-discover-gradient opacity-90 blur-[2px]" />
                <div className="relative flex items-center justify-center rounded-full bg-white text-transparent"
                    style={{ width: size - 4, height: size - 4 }}>
                    <Globe className="absolute text-sky-500" style={{ width: size * 0.7, height: size * 0.7 }} strokeWidth={1.5} />
                    <span className="relative font-black text-emerald-600"
                        style={{ fontSize: size * 0.55, letterSpacing: -1 }}>D</span>
                </div>
            </div>
            {showText && (
                <span className="font-black text-xl tracking-tight discover-gradient-text">
                    Discoveur
                </span>
            )}
        </div>
    );
}
